import { DisplayNames } from '.';
Object.defineProperty(Intl, 'DisplayNames', {
    value: DisplayNames,
    enumerable: false,
    writable: true,
    configurable: true,
});
//# sourceMappingURL=polyfill-force.js.map